import { RequestWithVersionInfo } from '../model/RequestWithVersionInfo';
import { ScheduleRequestInfo } from '../model/ScheduleRequestInfo';
import { GenericSchedule } from '../../model/schedulingModels/GenericSchedule';
import { GenericVersion } from '../../model/schedulingModels/GenericVersion';
import { GenericRequest } from '../../model/schedulingModels/GenericRequest';
import { ScheduleReferenceDates } from '../../model/ScheduleReferenceDates';

const fromScheduleAndStartActionDates = <Request extends GenericRequest, Version extends GenericVersion<Request>>(
  schedule: GenericSchedule<Version>,
  scheduleReferenceDates: ScheduleReferenceDates,
  allowGrouping = true,
): ScheduleRequestInfo<Request>[] => {
  const requestsWithVersionInfo = RequestWithVersionInfo.fromVersions(schedule.activeVersionWindows);

  const requestInfos = requestsWithVersionInfo.map(
    request => ScheduleRequestInfo.from(request, scheduleReferenceDates) as ScheduleRequestInfo<Request>,
  );

  if (schedule.groupByScheduleCode && allowGrouping) {
    // Merge all requestInfos into 1 requestInfo
    const groupedRequest = ScheduleRequestInfo.merge(requestInfos);
    return groupedRequest ? [groupedRequest] : [];
  } else {
    return requestInfos;
  }
};

const from = <
  Request extends GenericRequest,
  Version extends GenericVersion<Request>,
  Schedule extends GenericSchedule<Version>,
>(
  schedules: Schedule[],
  scheduleReferenceDates: ScheduleReferenceDates,
  allowGrouping = true,
): ScheduleRequestInfo<Request>[] =>
  schedules.flatMap(schedule =>
    fromScheduleAndStartActionDates<Request, Version>(schedule, scheduleReferenceDates, allowGrouping),
  );

export const ScheduleRequestInfoMapper = {
  from,
};
